import i18next from 'i18next';

i18next.addResources('es_CL', 'CallCenterCancelOrderModal', {
  modalTitle: 'Estas cancelando el pedido',
  modalSubtitle: 'Al cancelar se van a perder todos los productos agregados al carrito',
  cancelConfirmation: '¿Seguro que quieres cancelar el pedido?',
  buttonCancel: 'Si, cancelar el pedido',
  buttonBackToOrder: 'Volver al pedido'
});
